import VueSocketIO from 'vue-socket.io'
import {store} from '@/integrations/store'
import {io} from 'socket.io-client'

const url = `${store.getters['appOauth'].replace('https', 'wss').replace('//login.', '//wss.')}:2096`
const auth = {
  accessToken: store.getters['user/userTokenAccess'] || store.getters['user/userTokenAdmin']
}

const socket = new VueSocketIO({
  debug: true,
  connection: io(url, {auth})
})

export default socket
